























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class Prestations extends Vue {
    @Prop() outdoorArea: string
    @Prop() security: string
    @Prop() comfort: string
    @Prop() interiorEquipment: string
    prestas = [
        {
            title: 'Espaces extérieur',
            icon: 'logement-etage-premier.png',
            content: this.outdoorArea && this.outdoorArea.split('\n'),
        },
        {
            title: 'Sécurité',
            icon: 'logement-ouest.png',
            content: this.security && this.security.split('\n'),
        },
        {
            title: 'Confort',
            icon: 'logement-espace-exterieur-petit.png',
            content: this.comfort && this.comfort.split('\n'),
        },
        {
            title: 'Equipement intérieur',
            icon: 'logement-etage-premier.png',
            content:
                this.interiorEquipment && this.interiorEquipment.split('\n'),
        },
    ]
}
